import type { LiveWindResponse } from 'types/liveWind';

import { getKbygQueryParams } from 'hooks/useCameraURLManagement';
import baseFetch, { createParamString } from '../baseFetch';

/**
 * Fetches live wind data for a specific spot within a time range.
 * @param spotId - The ID of the spot to fetch wind data for
 * @param start - Start timestamp (Unix timestamp)
 * @param end - End timestamp (Unix timestamp)
 * @param interval - Data interval in minutes (default: 10)
 * @param params - Additional query parameters including noCache flag
 * @returns Promise resolving to live wind response data
 */
const fetchLiveWind = (
  spotId: string,
  start: number,
  end: number,
  interval: number = 10,
  params: Record<string, string | boolean> = { noCache: false },
): Promise<LiveWindResponse> => {
  const noCacheParam = params?.noCache;
  const kbygQueryParams = getKbygQueryParams(params);

  const headers = new Headers();
  if (noCacheParam) {
    headers.set('Cache-Control', 'no-cache');
  }

  return baseFetch<LiveWindResponse>(
    `/kbyg/spots/live/wind?${createParamString({
      ...kbygQueryParams,
      spotId,
      start,
      end,
      interval,
    })}`,
    {
      headers,
    },
  );
};

export default fetchLiveWind;
